import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import AdminPanel from './pages/Adminpanel';
import AdminLogin from './pages/AdminLogin';
import AdminSignUp from './pages/AdminSignup';
import ConfirmEmailPage from './pages/ConfirmEmailPage'; // ✅ New import

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showSignup, setShowSignup] = useState(false);

  // Check if admin is already logged in on mount
  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_email');
    setIsAuthenticated(false);
  };

  const handleNavigateToSignup = () => setShowSignup(true);
  const handleNavigateToLogin = () => setShowSignup(false);

  // Loading spinner while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  // ─── Main App ─────────────────────────────────────────────────────────────────
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>

          {/* ✅ Email confirmation route — always accessible, no auth needed */}
          <Route path="/confirm-email" element={<ConfirmEmailPage />} />

          {/* ✅ All other routes — auth-based rendering */}
          <Route
            path="*"
            element={
              isAuthenticated ? (
                // ── Logged In: Show Admin Panel ──
                <AdminPanel onLogout={handleLogout} />
              ) : showSignup ? (
                // ── Not Logged In: Show Signup ──
                <AdminSignUp
                  onNavigateToLogin={handleNavigateToLogin}
                  onLoginSuccess={handleLoginSuccess}
                />
              ) : (
                // ── Not Logged In: Show Login ──
                <AdminLogin
                  onLoginSuccess={handleLoginSuccess}
                  onNavigateToSignup={handleNavigateToSignup}
                />
              )
            }
          />

        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;